module.exports = __webpack_public_path__ + "static/open-sans-regular-5f4d4bc11d64b6cb605b7030c1997270.eot";